import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=44a0946c&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=44a0946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0946c",
  null
  
)

export default component.exports